import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Searchbar } from 'react-native-paper';

import { ArrowBackIcon, CloseIcon } from '@/assets';
import { MAX_SEARCH_LENGTH } from '@/constants/search';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { isEmptyOrNull } from '@/shared/utils/string';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  value: string;
  onChangeText: (text: string) => void;
  onBackPress: () => void;
};

export const OrganizationSearchBar: FC<Props> = ({
  value,
  onChangeText,
  onBackPress
}) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'components.organization-search'
  });

  return (
    <Searchbar
      // oxlint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      mode="view"
      placeholder={t('placeholder')}
      value={value}
      maxLength={MAX_SEARCH_LENGTH}
      onChangeText={onChangeText}
      onIconPress={onBackPress}
      style={{ backgroundColor: theme.colors.surfaceContainerLow }}
      icon={({ color, size }) => (
        <ArrowBackIcon fill={color} width={size} height={size} />
      )}
      clearIcon={({ color, size }) =>
        !isEmptyOrNull(value) && (
          <CloseIcon fill={color} width={size} height={size} />
        )
      }
    />
  );
};
